import { z } from 'my-zod'
import { tableViewSystemView } from './table-view-system-view'

export const tableViewAdminView = tableViewSystemView
export type tableViewAdminView = z.infer<typeof tableViewAdminView>
